// Client mirror of the Firestore rules' permission check (Phase E1).
// Admins/owners short-circuit to full access in the rules, so they bypass the
// per-key grants here too; a non-admin employee is allowed a capability only if
// users/{uid}.permissions[key] is explicitly true (deny-by-default). This is UI
// gating only — the Firestore rules are the real guard.
export function hasPerm(userProfile, key) {
	if (!userProfile) return false;
	if (userProfile.role === 'admin' || userProfile.owner === true) return true;
	return userProfile.permissions?.[key] === true;
}

// True only for the privileged tier the rules treat as admin (getUserRole() ==
// 'admin'). Owners carry role 'admin' too today, but this deliberately mirrors
// the rules' isAdmin() — NOT isOwner() — for gating admin-only actions such as
// schedule generation and the various admin-only deletes.
export function isAdminRole(userProfile) {
	return userProfile?.role === 'admin';
}

// Mirrors the payments / billing read rule: `isAdmin() || isOwner()`. Used to
// decide whether a staff member may see billing at all (teachers never do).
export function canViewBilling(userProfile) {
	return userProfile?.role === 'admin' || userProfile?.owner === true;
}

// Editing or deleting a Song Note, and removing / restoring a song from a
// student's repertoire (Anthony, 2026-09-27: "just for admin"). Mirrors the
// rules' `isAdmin() || isOwner()` on songNotes / repertoire / studentTracks;
// teachers still write notes and move their status.
export function canManageSongContent(userProfile) {
	return userProfile?.role === 'admin' || userProfile?.owner === true;
}

// A Firestore read rejected by security rules throws a FirebaseError whose code
// is 'permission-denied'. Distinguish that from a genuinely empty result so a
// denial renders an explicit "no access" state instead of fake-empty data.
export function isPermissionDenied(err) {
	if (!err) return false;
	if (err.code === 'permission-denied') return true;
	const msg = err.message || '';
	return msg.includes('Missing or insufficient permissions');
}
